export default __webpack_public_path__ + "static/media/Spin-07s-201px.8b25d1c0.png";